import React from "react";
import StaffSidebar from "./StaffSidebar";
import StaffHeader from "./StaffHeader";

const StaffLayout = ({ children }) => {
  return (
    <div className="flex min-h-screen bg-gray-100">
      <StaffSidebar />
      {/* when sidebar is fixed we add left padding on large screens so content doesn't overlap */}
      <div className="flex-1 lg:pl-64">
        <StaffHeader title="Staff" />
        <main className="p-6">{children}</main>
      </div>
    </div>
  );
};

export default StaffLayout;
